// extracted by mini-css-extract-plugin
module.exports =  {"gridColumn":"SmallGrid-SmallGrid-gridColumn-f70e6681"};